import type { ExternalAuthenticationConfig } from '../../common/types/authentication';
import type { FeatureFlags } from '../../common/types/featureFlags.js';
import type { GenesysChatConfig } from '../../common/types/genesysChat';

export interface ConfigState {
  classicSiteUrl: string;
  siteBaseUrl: string;
  // If missing, defaults to all true
  featureFlags: FeatureFlags;
  imagesBaseUrl: string;
  ringBaseUrl: string;
  externalAuthentication: ExternalAuthenticationConfig;
  genesysChat?: GenesysChatConfig;
  consumerMobiilivarmenneUrl?: string;
  elisaIdRegisterUrl: string;
  googleReCaptchaSiteKey?: string;
  offerRequestCampaignId?: string;
}

// Non-React face of `config` — for loaders and other non-React code.
let config: ConfigState = {
  classicSiteUrl: '',
  elisaIdRegisterUrl: '',
  externalAuthentication: { clientId: '', baseUrl: '' },
  featureFlags: {},
  imagesBaseUrl: '',
  siteBaseUrl: '',
  ringBaseUrl: '',
};

const listeners = new Set<() => void>();

export const setConfig = (newConfig: ConfigState): void => {
  config = newConfig;
  listeners.forEach(listener => listener());
};

// Non-React accessor — for loaders / non-React code
export const getConfig = (): ConfigState => config;

export const getFeatureFlags = (): FeatureFlags => config.featureFlags;

// Subscription glue for useSyncExternalStore (React face, see ConfigProvider.tsx)
export const subscribeConfig = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
